import FieldMultiselect_PopoverMenu from "./components/popover/popover-menu";
import FieldMultiselect_FormValueEmpty from "./components/form/value-empty";
import FieldMultiselect_FormValueNotEmpty from "./components/form/value-not-empty";
import FieldMultiselect_InlineValueEmpty from "./components/inline/value-empty";
import FieldMultiselect_InlineValueNotEmpty from "./components/inline/value-not-empty";
import FieldDropdown_ManagementForm from "../dropdown/render/management-form";
import FieldMultiselect_ManagementPreview from "./render/management-preview";
import FieldMultiselect_InlineEditable from "./render/inline-editable";
import FieldMultiselect_ViewSmall from "./render/view-small";
import FieldMultiselect_View from "./render/view";
import FieldMultiselect_FormElement from "./render/form-element";
import FieldConfig from "../../proto/field-config";
import {GROUP_SELECT} from "../../../gd/const/fields/field2-groups";
import FieldDropdown from "../dropdown/dropdown";
import FieldDropdown_PopoverMenuMore from "../dropdown/components/popover/popover-menu-more";
import FieldMultiselect_Pill from "./components/pill";
import FieldMultiselect_GlistView from "./render/glist-view";
import FieldMultiselect_AutomationTriggerForm from "./render/automation-trigger";
import FieldMultiselect_AutomationConditionForm from "./render/automation-condition";
import FieldMultiselect_AutomationActionForm from "./render/automation-action";
import FieldMultiselect_FormElementView from "./render/form-element-view";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldMultiselect_Editable from "./render/editable/editable";
import FieldMultiselect_PopoverOption from "./components/option/option";
import FieldMultiselect_TableCell from "./render/table/table-cell";
import FieldMultiselect_Picker from "./render/picker"
import {FieldFilterType} from "../../proto/types";
import {SortDirection} from "../../../data-structures/sort";
import ItemModel from "../../../model2/item/item-model";

export default class FieldMultiselect extends FieldDropdown {

    FIELD_DEFAULT_WIDTH             = 150

    public allValuesOption          : any   // if true will add all values option to options list (by default false)
    public allValuesOptionLabel     : string    // Label for all values option

    public pillMaxWidth             : number = 100       // max width in pixels used in list/table view to detect number ot pills we can show

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel              = "Multiselect";
        this.filterType             = FieldFilterType.MULTISELECT;
        this.typeGroup              = GROUP_SELECT
        this.typeDescription        = "Multiple selection field"
        this.icon                   = 'i5-dropdown';

        this.isColorCodingAvailable = false
        this.isGroupByAvailable     = false;    // redefine
        this.formType               = 'select';

        this.noValueOption          = _.get(config,'addNoValueOption',false);       // redefine parent
        this.noValueOptionLabel     = _.get(config,'noValueOptionLabel','None');    // redefine parent

        // MULTISELECT SPECIFIC
        this.allValuesOption        = _.get(config,'addAllValueOption',false);
        // patch to support allValuesOption key
        if (!_.isNil(config.allValuesOption)) this.allValuesOption = _.get(config,'allValuesOption',false);

        this.allValuesOptionLabel   = _.get(config,'allValuesOptionLabel','All');

        _.assign(this.components, {
            PopoverMenuMore:        this.showMenuMore ? FieldDropdown_PopoverMenuMore : null,

            FormValueEmpty:         FieldMultiselect_FormValueEmpty,
            FormValueNotEmpty:      FieldMultiselect_FormValueNotEmpty,
        })

        this.components.PopoverMenu     = FieldMultiselect_PopoverMenu
        this.components.PopoverOption   = FieldMultiselect_PopoverOption

        this.components.Pill            = FieldMultiselect_Pill // this is component we use in inline edit, form - popover option is different becasue of font size

        this.components.InlineValueEmpty        = FieldMultiselect_InlineValueEmpty
        this.components.InlineValueNotEmpty     = FieldMultiselect_InlineValueNotEmpty

        _.assign(this.classes, {
            PopoverMenu                 : '', // to add classes for popover menu shell
            PopoverMenuScrollContainer  : 'max-h-200', // to add classes for popover menu scroll container (max-h-200 for example)
        })

        _.assign(this.renderComponents, {
            inlineEditable              : FieldMultiselect_InlineEditable,

            glistView                   : FieldMultiselect_GlistView,

            managementPreview           : FieldMultiselect_ManagementPreview,
            managementForm              : FieldDropdown_ManagementForm,

            formElement                 : FieldMultiselect_FormElement,
            formElementView             : FieldMultiselect_FormElementView,

            automationTriggerForm       : FieldMultiselect_AutomationTriggerForm,
            automationConditionForm     : FieldMultiselect_AutomationConditionForm,
            automationActionForm        : FieldMultiselect_AutomationActionForm,

            picker                  : FieldMultiselect_Picker,
        })

        this.renderComponents.tableCell     = FieldMultiselect_TableCell // Not editable because editable is multiline not single line
        this.renderComponents.editable      = FieldMultiselect_Editable

        this.renderComponents.view          = FieldMultiselect_View
        this.renderComponents.viewSmall     = FieldMultiselect_ViewSmall
    }

    isEmpty(model:any) {
        let currentModelValue : any[] = this.getViewValue(model)

        return _.isEmpty(currentModelValue)
    }

    hasValue(model:any, optionValue:any):boolean {
        let currentModelValue : any[] = this.getViewValue(model)

        if (!currentModelValue || !_.isArray(currentModelValue)) return false

        return currentModelValue.includes(optionValue)
    }

    toggleValue(model:any, optionValue:any) {
        if (this.hasValue(model, optionValue)) {
            return this.removeValue(model, optionValue)
        } else {
            return this.addValue(model, optionValue)
        }
    }

    addValue(model:any, optionValue:any) {

        // Clone is important here (!) otherwise when we modify it will be same object and we wont be able to compare
        let value : any[] = _.clone(this.getViewValue(model))

        if (!value || !_.isArray(value)) {
            value = []
        }

        // why add if already there ?
        if (this.hasValue(model, optionValue)) {
            // its there already
        }

        value.push(optionValue)

        return value
    }

    removeValue(model:any, optionValue:any) {
        // Clone is important here (!) otherwise when we modify it will be same object and we wont be able to compare
        let value : any[] = _.clone(this.getViewValue(model))

        if (!value || !_.isArray(value)) {
            value = []
        }

        value.remove(optionValue)

        return value
    }


    /*** DATA FUNCTIONS ***/

    getValueOptions(model:any) {
        const value = this.getViewValue(model)

        if (_.isEmpty(value)) return [] // false; // value = array (!)

        const valueOptions   = this._getOptions(value)

        return valueOptions
    }

    getOptions() {
        // add no value option if required
        const noValue = this.noValueOption ? [{value: null, label: this.noValueOptionLabel}] : null;

        if (noValue) {
            // @ts-ignore
            return noValue.concat(this.options)
        } else {
            return this.options
        }

    }

    // Multiselect specific values -> options
    public _getOptions(values:any[]):any {

        // value is array
        if (!_.isArray(values)) return false



        if (values) {
            const options = _.filter(this.getOptions(), (option) => {
                return values.includes(option.value)
            });
            if (options) return options;
        }

        return false;
    }

    searchValue(value:any) {
        const options = this._getOptions(value);
        return options ? _.map(options, o=>o.label).join(' ').toLowerCase() : '';
    }

    listItemSortFunctions(sort: SortDirection): any {
        return {
            functions: [
                (listItem:ItemModel) => {
                    return this._getOptions(listItem.item[this.fieldId as keyof {}]).length || 0
                },
                (listItem:ItemModel) => {
                    const options = this._getOptions(listItem.item[this.fieldId as keyof {}])
                    return options ? _.map(options, o=>o.label).join(' ').toLowerCase() : ''
                }
            ],
            directions: [sort, sort]
        }
    }

    /*** IMPORT EXPORT ***/

    normalizeToCSVValue(model: any): any {
        const rawValue = _.get(model, this.fieldId, '')

        let res: string[] = []
        _.map(rawValue, v=>{
            const option = _.find(this.getOptions(), o => o.value === v)
            if (option) res.push(option.label)
        })
        return res.join(', ')
    }

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        let selectedValues: string[] = value ? value.split(', ') : []
        selectedValues = _.map(selectedValues, (value: string) => value.toLowerCase())

        const ids: string[] = []
        _.map(selectedValues, (value: string): void => {
            const searchValue: string = value.toLowerCase()
            const option = _.find(this.getOptions(), o => searchValue === o.label.toLowerCase())
            if (option) ids.push(option.value)
        })

        return ids
    }

    toJson() {
        let result = super.toJson();
        result.options = this.options;

        return result;
    }
}
